import { defineNuxtPlugin } from '#app';
import globalMixin from '~/mixins/index.global';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.mixin(globalMixin);
});
